import { connect } from 'react-redux';
import { Graphics as Component } from './Graphics';

import {
  solutionOpen,
  toggleModalHB,
  setTemperatureHB,
  onTubeDropHB,
  checkBalanceHB,
  temperatureBalanceHB,
  tooltipDisplayHB,
  tooltipRemoveHB,
  tubeTooltipDisplayHB,
  tubeTooltipRemoveHB,
  removeTubeFromHeatblockHB,
  setSolutionInScene,
  addTubeToIceBucket,
  setSolutionOnRack,
  setSolutionOnIce,
} from '@learningblocks/protocol-redux/lib/Actions';

function mapStateToProps(state, ownProps) {
  return {
    id: ownProps.id,
    type: state.notebook.protocolSection.scene.apparatus.heatBlocks[ownProps.id - 1].type,
    temperature: state.notebook.protocolSection.scene.apparatus.heatBlocks[ownProps.id - 1].temperature,
    currentTemp: state.notebook.protocolSection.scene.apparatus.heatBlocks[ownProps.id - 1].currentTemp,
    balance: state.notebook.protocolSection.scene.apparatus.heatBlocks[ownProps.id - 1].balance,
    isModalOpen: state.notebook.protocolSection.scene.apparatus.heatBlocks[ownProps.id - 1].isModalOpen,
    tooltip: state.notebook.protocolSection.scene.apparatus.heatBlocks[ownProps.id - 1].tooltip,
    filledSlots: state.notebook.protocolSection.scene.apparatus.heatBlocks[ownProps.id - 1].filledSlots,
    slots: state.notebook.protocolSection.scene.apparatus.heatBlocks[ownProps.id - 1].slots,
    tubeTooltip: state.notebook.protocolSection.scene.apparatus.heatBlocks[ownProps.id - 1].tubeTooltip,
    isHeating: state.notebook.protocolSection.scene.apparatus.heatBlocks[ownProps.id - 1].isHeating,
    solutions: state.notebook.protocolSection.scene.apparatus.heatBlocks[ownProps.id - 1].solutions
  }
}

function mapDispatchToProps(dispatch) {
  return {
    solutionOpen: (data) => {
      dispatch(solutionOpen(data))
    },
    toggleModalHB: (data) => {
      dispatch(toggleModalHB(data))
    },
    setTemperatureHB: (data) => {
      dispatch(setTemperatureHB(data))
    },
    onTubeDropHB: (data) => {
      dispatch(onTubeDropHB(data))
    },
    checkBalanceHB: (data) => {
      dispatch(checkBalanceHB(data))
    },
    temperatureBalanceHB: (data) => {
      dispatch(temperatureBalanceHB(data))
    },
    tooltipDisplayHB: (data) => {
      dispatch(tooltipDisplayHB(data))
    },
    tooltipRemoveHB: (data) => {
      dispatch(tooltipRemoveHB(data))
    },
    tubeTooltipDisplayHB: (data) => {
      dispatch(tubeTooltipDisplayHB(data))
    },
    tubeTooltipRemoveHB: (data) => {
      dispatch(tubeTooltipRemoveHB(data))
    },
    removeTubeFromHeatblockHB: (data) => {
      dispatch(removeTubeFromHeatblockHB(data))
    },
    setSolutionInScene: (data) => {
      dispatch(setSolutionInScene(data))
    },

    addTubeToIceBucket: (data) => {
      dispatch(addTubeToIceBucket(data))
    },

    setSolutionOnRack: (data) => {
      dispatch(setSolutionOnRack(data))
    },

    setSolutionOnIce: (data) => {
      dispatch(setSolutionOnIce(data))
    },
  };
}

export const Graphics = connect(
  mapStateToProps,
  mapDispatchToProps
)(Component);
